import { Box } from '@mui/material';
import { DealForm } from 'components/featured/Deals/components/DealForm';

const DealNew = () => {
  return (
    <Box sx={{ height: 'calc(100vh - 160px)' }}>
      <DealForm isEdit={false} />
    </Box>
  );
};

export default DealNew;
